import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Router, ActivatedRoute } from "@angular/router";

import { OtherProduct } from './../../shared/models/products/other-product';
import { PurchaseStateService } from './../../shared/services/purchase-state.service';
import { NotificationsService } from './../../../shared/services/notifications.service';
import { ViewStateService } from './../../../shared/services/view-state.service';

@Component({
  selector: 'app-other-product',
  templateUrl: './other-product.component.html',
  styleUrls: ['./other-product.component.css'] 
})
export class OtherProductComponent implements OnInit {
  productForm: FormGroup;
  product: OtherProduct;

  get isPin(): boolean {
    if (!this.product) return false;
    return this.product.title.toLowerCase().indexOf(' pin') > -1;
  }

  constructor(private purchaseState: PurchaseStateService,
    private formBuilder: FormBuilder,
    private router: Router,
    private notifications: NotificationsService,
    private viewState: ViewStateService)
    { }

  ngOnInit() {
    this.product = <OtherProduct>this.purchaseState.getTempProductData();    
    this.buildForm();
  }

  onSubmit(updatedFormValue) {
    this.formValues = updatedFormValue;

    this.validateForm();
    if(this.productForm.valid){
      this.updatePurchaseState();

      this.router.navigate(["purchase/checkout"])
    }
  }

  onBack(event:Event) {
    event.preventDefault();

    this.router.navigate([this.purchaseState.previousRouteUrl])
  }

  private updatePurchaseState() {
    this.product.initials = this.formValues.initials;
    this.product.quantity = this.formValues.quantity;
    this.purchaseState.patchProducts(this.product)
  }

  public hideQuantity() {
    return this.product.code.charAt(0) !== "I"
  }

  private buildForm() {
    this.productForm = this.formBuilder.group({
      'quantity':[this.product.quantity, [
        Validators.required,
        Validators.min(1),
        Validators.max(10)
        ]
      ],
      'initials':[this.product.initials]
    });
  }

  private validateForm() {
    for(const control in this.productForm.controls) {
      this.productForm.controls[control].updateValueAndValidity();
    }

    let hasErrors = false;
    for (const field in this.formErrors) {
      this.formErrors[field] = '';
      const control = this.productForm.get(field);

      if (field === "initials" && this.isPin && !control.value)
        control.setErrors({'required': true});

      if (control && control.invalid) {
        hasErrors = true;
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] += messages[key] + ' ';
        }
      }
    }
    if (hasErrors) {
      this.notifications.error("Form Error", "Please check the form values.")
      this.viewState.stopLoading();
    }
  }

  formErrors = {
    'quantity': '',
    'initials':''
  }

  formValues = {
    'quantity': 1,
    'initials': ''
  }

  validationMessages = {
    'quantity': {
      'required':'Quantity is required.',
      'min':'Quantity must be greater than 0.',
      'max':'Quantity must be 10 or less.'
    },
    'initials' : {
      'required': 'Initials are required.'
    }
  }
}
